class NSSComparisonTable extends HTMLElement {
  constructor() {
    super();

    this.debug = false;
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Comparison Table] Connected.`);

    this.addEventListener(`click`, this.handleClick.bind(this));
  }

  handleClick(e) {
    if (this.debug) console.log(`[NSS][Comparison Table] Clicked!`);

    if (e.target.hasAttribute(`nss-selected-column-btn`)) {
      e.target.parentElement.classList.toggle(`nss-active`);
    }

    if (e.target.hasAttribute(`nss-column-id`)) {
      const id = e.target.getAttribute(`nss-column-id`);

      const btnEls = this.querySelectorAll(`button[nss-column-id]`);
      btnEls.forEach((btnEl) => btnEl.classList.remove(`nss-active`));
      e.target.classList.add(`nss-active`);

      const activeEl = this.querySelector(`.nss-comparison-table__column.nss-active`);
      activeEl.classList.remove(`nss-active`);

      const newEl = this.querySelector(`.nss-comparison-table__column[nss-column-id="${id}"]`);
      newEl.classList.add(`nss-active`);

      const selectedColumnEl = this.querySelector(`[nss-selected-column]`);
      selectedColumnEl.textContent = e.target.textContent;

      this.querySelector(`.nss-comparison-table__button-selected`).parentElement.classList.remove(
        `nss-active`
      );
    }
  }
}

let elementName = `nss-comparison-table`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSComparisonTable);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
